import React, { useState } from 'react';
import style from "./Pagination.module.css";
import { Pagination, Select } from 'antd';

const DefaultPagination = ({ title,  handlePaging, idLimit, initiate, current, background, idPagination, selectedRowPage, changeRowPerPage }) => {
  const [dropdownArrow, setArrow] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        background: background ? background : null,
        height: "40px",
      }}
    >
      <div className="custom-props">
        <div style={{ display: "flex" }}>
          <span 
            style={{ 
              marginTop: "auto", 
              marginBottom: "auto", 
              marginLeft: 8, 
              marginRight: 8, 
              color: "#1A1A1A", 
              fontWeight: 500 
            }}>
              {title}
            </span>
          <div 
            className={
              background ? style.WrapCustom : style.WrapDefault
            }
          >
            <Select
              id={idLimit}
              style={{ width: 50, height:28, paddingRight: '10px' }}
              value={selectedRowPage ? selectedRowPage : 10}
              onChange={(value) => changeRowPerPage(value)}
              onDropdownVisibleChange={(open) => { setArrow(open) }}
              // suffixIcon={ dropdownArrow ? <ChevronUpPagination /> : <ChevronDownPagination /> }
            >
              {initiate?.valid_limit &&
                initiate?.valid_limit?.map((item) => (
                  <Select.Option value={item} key={item}>
                    {item}
                  </Select.Option>
                ))}
            </Select>
          </div>
        </div>
      </div>
      <div id={idPagination} className={style.Wrap}>
        <Pagination
          current={current}
          onChange={(value) => { handlePaging(value) }} 
          total={initiate?.count_data ? initiate?.count_data : 0 }
          pageSize={selectedRowPage}
        />
      </div>
    </div>
  );
}

export default DefaultPagination;